<template>
  <div class="question_style">
    <div class="arr_style">
      <el-link :underline="false" type="info" @click="logo_click">CGM制药</el-link>
      <div class="arrow_style">></div>
      <div class="arrow_style">常见问题</div>
    </div>
    <div class="ques_style">常见问题</div>
    <div class="we_style">
      我们回答了很多问题、如果您对详细操作有任何疑问、请参阅如下帮助文章。
    </div>
    <div class="coll_style">
      <el-collapse>
        <el-collapse-item title="家庭配置药都有哪些？" name="1">
          <div>CGM制药为家庭配置药研发了成人感冒药、儿童感冒药、消炎药、止痛药、退烧贴、胃药等共计8款家庭用药。我们还在陆续的推出新款家庭用药。
          </div>
        </el-collapse-item>
        <el-collapse-item title="如果没有服用过期了怎么办？" name="2">
          <div>CGM家庭配置药有独特的退换模式、如果您的家庭未使用已经购买的药品并已过期、我们会为您免费替换新日期的药品、所以不用担心购买的药过期的现象。
          </div>
        </el-collapse-item>
        <el-collapse-item title="有过敏的成分怎么办？" name="3">
          <div>您在购买我们的药品时、会填写家庭的情况、尤其是家庭对某些成分过敏的现象需通知我们、我们会移除相关的药物、为您匹配更合适的配置药。
          </div>
        </el-collapse-item>
        <el-collapse-item title="配置药我只需要其中3款怎么办？" name="4">
          <div>是可以的、如果8款药中您只需要其中三款可以单独购买。
          </div>
        </el-collapse-item>
        <el-collapse-item title="购买后大概多久可以送到？" name="5">
          <div>当日下单、次日发货的模式在运作、大概7至10天可以国际送达、还请您耐心等待、提前配置避免家庭需要时没有药哦。
          </div>
        </el-collapse-item>
        <el-collapse-item title="日本医药品进口合法吗？" name="6">
          <div>我们根据您的个人信息报备在海关、并进行了缴纳关税、请您放心服用。
          </div>
        </el-collapse-item>
        <el-collapse-item title="如何服用我们该询问谁？" name="7">
          <div>您可以咨询我们城市代理商的相关医疗人员、也可以线上咨询CGM制药客服、都会为您解答最准确的服用方式。
          </div>
        </el-collapse-item>
        <el-collapse-item title="CGM的药品安全吗？" name="8">
          <div>请您放心、我们是日本药监局合法批准的处方、并通过临床。CGM药品已经进入到日本各大实体药妆店、为日本国民提供了安全的用药。
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="medical_style">
      <div class="me_style">
        <img src="../assets/img/app-photo.png" class="app_img_style" />
      </div>
      <div class="first_style">
        <div class="first_bold_style">全球首款</div>
        <div class="first_bold_style">跨境互联网医疗平台</div>
        <div class="first_bold_style1">日本医师在线处方・精准服用合法进口处方药 您的疾病得到更好的治疗。
        </div>
        <div class="medical_href_style" @click="medical_click">
          <img src="../assets/img/logo.png" class="logo_img_style" />
          <div class="enter_style">点击进入</div>
        </div>
        <div>加速推进全球医药品合法流通</div>
      </div>
    </div>
  </div>
</template>
<script>
import { medical_href } from "../assets/config/img";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      activeNames: ["1"],
    };
  },
  mounted() {},
  methods: {
    logo_click() {
      if (this.cgmUserVO) {
              let userId = JSON.parse(this.cgmUserVO).userId;
              this.axios
                .get("/cgmOrder/getOrderCount", {
                  params: {
                    userId,
                  },
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.configFlag = res.data.data;
                    if(res.data.data > 0){
                      this.$router.push("/ConfigMedicine");
                    }else{
                      this.$router.push("/Firstindex");
                    }
                  }
                });
              }
    },
    handleChange(val) {
      console.log(val);
    },
    medical_click() {
      window.open(medical_href);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
  padding: 20px;
  font-size: 17px;
  font-weight: bold;
}
::v-deep .el-collapse-item__content {
  padding: 0 20px 20px 20px;
  font-size: 14px;
}
@media (max-width: 768px) {
  .medical_style {
    padding: 40px !important;
    flex-direction: column;
    // display: unset !important;
  }
  .me_style {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .app_img_style {
    width: 70% !important;
  }
  .first_style > div {
    margin-bottom: 20px !important;
    // text-align: center;
  }
  .question_style > div {
    width: 100% !important;
  }
  .question_style {
    padding: 40px 10px !important;
    align-items: flex-start !important;
  }
}
.coll_style {
  // padding: 40px;
  margin-bottom: 40px;
}
.arrow_style {
  color: #778899;
  font-size: 14px;
}
.arr_style {
  display: flex;
  gap: 7px;
  margin-bottom: 20px;
}
.ques_style {
  font-weight: bold;
  font-size: 32px;
  margin-bottom: 40px;
}
.we_style {
  margin-bottom: 40px;
}
.question_style > div {
  width: 64%;
}

.question_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f6f7;
  padding: 40px 0;
}

.medical_style {
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #e51c51;
  color: #fff;
  border-radius: 10px;
  padding: 40px 40px 40px 80px;
  margin-bottom: 100px;
}
.me_style {
  // flex: 1;
  // margin-left: 20px;
  width: 300px;
}
.app_img_style {
  width: 100%;
}

.first_style > div {
  margin-bottom: 20px;
  // font-size: 18px;
}
.first_bold_style {
  font-weight: bold;
  font-size: 22px;
}
.first_bold_style1 {
  font-weight: bold;
  font-size: 14px;
}
.medical_href_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.logo_img_style {
  width: 144px;
}
.enter_style {
  background: #000;
  color: #fff;
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: bold;
}
</style>